import { Location } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastsManager } from 'ng2-toastr';
import { Observable, Subject } from 'rxjs';
import { BaseComponent } from '../../core/components';
import { IPagedResults } from '../../core/interfaces';
import { GuardService } from '../../services';
import { modalLarge } from '../../shared/modules/dialogOptions';
import { GuardEditComponent } from './guard-edit.component';
@Component({
    selector: 'app-guard-list',
    templateUrl: './guard-list.component.html',
    styleUrls: ['./guard-list.component.scss']
})
export class GuardListComponent extends BaseComponent implements OnInit {
    deleteId: any;
    modalReference: NgbModalRef;
    siteId: number;
    @Output()
    DeletedGuard = new EventEmitter<any>();
    public showSpinner: boolean = false;
    public itemPerPage: number = 10;
    public currentPage: number = 1;
    public totalItems: number = 10;
    public isAdminOrUserEditor = false;
    public isSuperAdmin = false; 5
    public isPreviewOn: boolean = false;
    constructor(
        private toastr: ToastsManager,
        private guardService: GuardService,
        public router: Router,
        private modalService: NgbModal,
        private route: ActivatedRoute,
        private location: Location) {
        super(router)
    }
    packageData: Subject<any> = new Subject<any[]>();

    ngOnInit() {
        if (this.isSuperAdmin && !super.secondaryAdminUser()) {
            this.loadData();
        }
    }

    public loadData(page?: number, id?: number) {
        this.showSpinner = true;
        let filter = '';
        if (page != null) {
            this.currentPage = page;
        }

        this.guardService.getGuardEmployees(0, 0)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                    this.showSpinner = false;
                }, 1000);
            })
            .subscribe((response: IPagedResults<any>) => {
                this.packageData.next(response.Data);
                this.totalItems = response.Data.length;
                //   this.toastr.success(response.Message, "Success"); 
            });
    }

    public loadDataById(accountId: number, siteId: number) {
        this.siteId = siteId;
        this.showSpinner = true;
        this.guardService.getGuardEmployees(accountId, siteId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                    this.showSpinner = false;
                }, 1000);
            })
            .subscribe((response: IPagedResults<any>) => {
                this.packageData.next(response.Data);
                this.totalItems = response.Data.length;
                //  this.toastr.success(response.Message, "Success"); 
            });
    }

    public editGuard(id: number) {
        //this.router.navigate([`${id}/edit`], { relativeTo: this.route });  
        const modalRef = this.modalService.open(GuardEditComponent, modalLarge);
        modalRef.componentInstance.modalIdData = id;
        modalRef.componentInstance.modalSiteId = this.siteId;
        modalRef.result.then((result) => {

            let currentUser = super.currentLoggedUser();
            this.loadDataById(currentUser.accountId, this.siteId);
            this.ngOnInit();
            //alert(result);
            //this.loadDataById(result);
        }, (reason) => {

            let currentUser = super.currentLoggedUser();
            this.loadDataById(currentUser.accountId, this.siteId);
            this.ngOnInit();
            // alert(reason +"aaa");
        });
    }

    public deleteGuard(id: number) {
        //alert(id);
        this.guardService.deleteGuard(id).catch((err: any) => {
            return Observable.throw(err);
        })
            .finally(() => {
                setTimeout(() => {
                }, 1000);
            })
            .subscribe((response: any) => {
                if (response.Success) {
                    this.toastr.success(response.Message, "Success");
                } else {
                    this.toastr.error(response.Message, "Cannot delete");
                }
                this.modalReference.close();
                // this.ngOnInit();
                this.DeletedGuard.emit({ GuardId: id });
            });
        ;
    };

    openLg(content, id) {
        this.deleteId = id;

        // alert(this.deleteId);
        this.modalReference = this.modalService.open(content);
    }

}



// WEBPACK FOOTER //
// ./src/app/components/guards/guard-list.component.ts